import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import { toDate } from 'shared/utilities';
import { DateType } from 'shared/types';
import { useSwipe } from 'shared/hooks';

import { CalendarPageDaysAllDay } from './components/CalendarPageDaysAllDay';
import { CalendarPageDaysDay } from './components/CalendarPageDaysDay';

import { Store } from 'pages/calendar/store';
import { CALENDAR_PAGE } from 'pages/calendar/constants/CALENDAR_PAGE';

import './styles.scss';

export const CalendarPageDays = observer(function CalendarPageDays() {
    const swipe = useSwipe({
        trackMouse: false,
        onSwipedLeft: Store.next,
        onSwipedRight: Store.prev,
    });

    const now = toDate();

    const days = Store.getDaysForView();

    return (
        <div className='calendar-page-days' {...swipe}>
            <div className='calendar-page-days-header'>
                <div className='calendar-page-days__time calendar-page-days__time--header' />
                {days.map(day => (
                    <div
                        key={day.format('YYYY-MM-DD')}
                        className={classnames('calendar-page-days-header-cell', {
                            'calendar-page-days-header-cell--today': day.isSame(now, 'day'),
                            'calendar-page-days-header-cell--weekend': day.day() === 0 || day.day() === 6,
                        })}
                    >
                        <div
                            className='calendar-page-days-header-cell__date'
                            onClick={() => {
                                Store.update({
                                    date: day,
                                    view: 'day',
                                });
                            }}
                        >
                            {day.format('D')}
                        </div>
                        <div className='calendar-page-days-header-cell__weekday'>{day.format('dd')}</div>
                    </div>
                ))}
            </div>
            <CalendarPageDaysAllDay days={days} />
            <div className='calendar-page-days__columns'>
                <div className='calendar-page-days__aside'>
                    {CALENDAR_PAGE.HOURS.map(hour => (
                        <div key={hour} className='calendar-page-days__time'>
                            <span>{hour.toString().padStart(2, '0') + ':00'}</span>
                        </div>
                    ))}
                </div>
                {days.map(day => (
                    <CalendarPageDaysDay key={day.format('YYYY-MM-DD')} date={day} />
                ))}
            </div>
        </div>
    );
});
